import { Navigate, useLocation } from "react-router-dom";
import { useMe } from "@/context/AuthContext";
import { Spinner } from "@/components/common/States";
import NotFound from "@/pages/NotFound";

export function RequireAuth({ children }) {
  const { isLoaded, isSignedIn, ready } = useMe();
  const { pathname, search } = useLocation();
  if (!isLoaded) return <Spinner />;
  if (!isSignedIn) return <Navigate to={`/sign-in?next=${encodeURIComponent(pathname + search)}`} replace />;
  if (!ready) return <Spinner />;
  return children;
}

export function RequireStaff({ children }) {
  const { isStaff, ready } = useMe();
  if (!ready) return <Spinner />;
  return isStaff ? children : <NotFound />;
}
